// Native writes these host-only cookies into a fresh incognito partition.
// This marker selects a storage policy, not an authorization decision.
export function readPortalCookie(cookie, name) {
  const matches = cookie.split(';').map(v => v.trim()).filter(v => v.startsWith(`${name}=`));
  if (matches.length !== 1) return null;
  try { return decodeURIComponent(matches[0].slice(name.length + 1)); }
  catch (_) { return null; }
}

export const harmonyPortal = typeof document !== 'undefined' &&
  readPortalCookie(document.cookie, '__Host-vmos-portal') === '1';

export function portalCredentials(cookie) {
  if (readPortalCookie(cookie, '__Host-vmos-portal') !== '1') return { token: null, userId: null };
  const token = readPortalCookie(cookie, '__Host-vmos-token');
  const userId = readPortalCookie(cookie, '__Host-vmos-userId');
  if (!token || token.length > 4096 || /[\r\n;]/.test(token) || !/^[1-9][0-9]{0,18}$/.test(userId || '')) {
    return { token: null, userId: null };
  }
  return { token, userId };
}

export function clearPortalCookies() {
  for (const key of ['__Host-vmos-token', '__Host-vmos-userId']) {
    document.cookie = `${key}=; Path=/; Secure; SameSite=Lax; Max-Age=0`;
  }
}
